
import OrderAppResource from '@sellers-shield-home-protection/ss-core-js/src/AppResources/OrderAppResource';
import getters from './getters';
import actions from './actions';

export default {
    namespaced: true,
    state: () => ({
        _allAssociatedOrders: [],
        _selectedOrderDetails: {
            
        },
    }),
    getters,
    actions,
};